export enum EVersionType {
  all = undefined,
  draft = 'DRAFT',
  published = 'PUBLISHED',
  archived = 'ARCHIVED',
}

export enum ERuleStatus {
  invalid = 'invalid',
  triage = 'triage',
  verified = 'verified',
  warning = 'warning',
}

export enum EOrganizationHierarchyLevel {
  organization = 'ORGANIZATION',
  labor_union = 'LABOR_UNION',
  location_group = 'LOCATION_GROUP',
  location = 'LOCATION',
}
